export const config = {
  title: "Hernandez Cleaning Services | Commercial Cleaning | Chicago, IL",
  meta: {
    description:
      "Hernandez Cleaning Services provides expert commercial cleaning in Chicago, IL. 20 years of experience, BBB accredited, insured & bonded. Specializing in restaurant, office, and building cleaning.",
    keywords: [
      "Hernandez Cleaning Services",
      "Commercial Cleaning Chicago",
      "Restaurant Cleaning",
      "Office Cleaning Chicago",
      "Floor Cleaning Services",
      "Building Cleaning",
      "Deep Cleaning Chicago",
      "Window Cleaning"
    ],
    author: "Hernandez Cleaning Services",
    canonicalUrl: "https://hernandezcleaningsvcs.com/",
  },
  sections: {
    header: {
      businessName: "Hernandez Cleaning Services",
    },
    sectionB: {
      heroTitle: "Transform Your Business With Expert Commercial Cleaning",
      heroSubtitle: "20 Years of Experience | BBB Accredited | Insured & Bonded",
      learnAboutText: "Get Your Free Quote",
      phoneNumber: "8724014380",
      phoneLabel: "(872) 401-4380",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2209016975/photo/young-man-in-uniform-vacuum-cleaning-the-floor-in-the-conference-room.jpg?s=612x612&w=0&k=20&c=ZMZxYxC4wiWGKkg4AFgzKmHQfpc5MU9XcCEogJYwBaQ=",
      cardData: [
        {
          title: "Restaurant Cleaning",
          description:
            "Professional restaurant cleaning ensuring kitchens, dining areas, and facilities meet health and safety standards.",
        },
        {
          title: "Office Cleaning",
          description:
            "Comprehensive office cleaning services creating a sanitary and organized workspace for productivity.",
        },
        {
          title: "Commercial Buildings",
          description:
            "Complete commercial building cleaning covering lobbies, restrooms, offices, and common areas.",
        },
      ],
      description:
        "For two decades, Hernandez Cleaning Services in Chicago, IL has built a legacy in commercial cleaning with BBB accreditation, comprehensive warranties, and expertise in kitchen and bar settings.",
    },
    sectionC: {
      servicesTitle: "Professional Commercial Cleaning Services",
      servicesDescription:
        "Expert commercial cleaning with 20 years of experience, BBB accreditation, and comprehensive warranties. We deliver excellence without compromise.",
      cards: [
        {
          title: "Restaurant & Kitchen Cleaning",
          description:
            "Thorough restaurant cleaning services ensuring kitchens, dining areas, floors, and restrooms meet health and safety standards with professional-grade solutions.",
          imageSrc: "https://media.istockphoto.com/id/1999331287/photo/restaurant-employee-cleaning-floor-in-kitchen.jpg?s=612x612&w=0&k=20&c=FGyzT-pMn91flmi0VEfE1J3kUoxaoHx3aVHcAMgiQnc=",
          imageAlt: "Restaurant Kitchen Cleaning",
        },
        {
          title: "Office & Building Cleaning",
          description:
            "Professional office cleaning covering desks, floors, restrooms, and communal areas with eco-friendly products and thorough techniques.",
          imageSrc: "https://media.istockphoto.com/id/1316473356/photo/an-employee-pulls-a-trolley-for-cleaning-offices-woman-cleaner-is-engaged-in-work.jpg?s=612x612&w=0&k=20&c=6QWgeQ8HQU4TvT4lu9l2hBLiKUVYLcF_6-deEMn-vb8=",
          imageAlt: "Office Building Cleaning",
        },
        {
          title: "Floor & Window Cleaning",
          description:
            "Expert commercial floor cleaning and window cleaning services using industry-grade equipment and eco-friendly solutions for spotless results.",
          imageSrc: "https://media.istockphoto.com/id/518333344/photo/office-deep-clean.jpg?s=612x612&w=0&k=20&c=matq8UJjpE5jYs6N3zOjLVZY6WAjwZcOns2Fx7-UmDQ=",
          imageAlt: "Floor and Window Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Deep Cleaning Services",
        "Nightclub Cleaning",
        "Same-Day Services",
        "Eco-Friendly Solutions",
        "Emergency Cleaning",
      ],
    },
    sectionD: {
      aboutTitle: "About Hernandez Cleaning Services",
      aboutImage: {
        src: "https://hernandezcleaningsvcs.com/img/about-img-1.webp",
        alt: "Hernandez Cleaning Services Team",
      },
      aboutText: [
        "For two decades, Hernandez Cleaning Services in Chicago, IL has built a legacy in commercial cleaning, earning certifications and BBB accreditation that speak volumes about our dedication. Armed with expertise, particularly in kitchen and bar settings, our focus remains clear: excellence without compromise.",
        "With comprehensive warranties and same-day services available, we ensure that quality is not just promised but delivered consistently. Our background steeped in understanding unique challenges sets us apart as a premier choice for those needing thorough solutions tailored to commercial environments.",
      ],
    },
    sectionE: {
      profileImage: "https://hernandezcleaningsvcs.com/img/icons/logo.webp",
      profileAlt: "Hernandez Cleaning Services",
      businessName: "Hernandez Cleaning Services",
      contact: {
        phone: "8724014380",
        phoneLabel: "(872) 401-4380",
        email: "hernandez030673@yahoo.com",
        website: "https://hernandezcleaningsvcs.com/",
        address: "3408 N Springfield Ave #1, Chicago, IL 60618",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "3408 N Springfield Ave #1, Chicago, IL 60618",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2965.5123456789!2d-87.7234567!3d41.9454567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fcb1234567890a%3A0x1234567890abcdef!2s3408%20N%20Springfield%20Ave%20%231%2C%20Chicago%2C%20IL%2060618!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;